
export const NUMBER_FORMATS = [
  new RegExp('^0?70(?:[1-9]{1}[0-9]{7})$'),
  new RegExp('^0?80(?:[2-9]{1}[0-9]{7})$'),
  new RegExp('^0?81(?:[0-9]{1}[0-9]{7})$'),
  new RegExp('^0?90(?:[2-9]{1}[0-9]{7})$')
]
